<template>
    <div class="box">
        <img class="logo" src="../assets/logo.webp" />
        <div class="btns">
            <div class="btn" v-for="btn in btns" :key="btn.name" @click="handleClick(btn.path)" :style="{
                backgroundColor: btn.name === cur ? '#02505D' : 'none',
                color: btn.name === cur ? '#fff' : '#4D4D4D'
            }">
                {{ btn.name }}
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps } from "vue";
import { useRouter } from "vue-router";
defineProps({
    cur: {
        type: String,
        required: true,
        default: "หน้าแรก",
    },
    bgColor: {
        type: String,
        required: true,
    }
});
const router = useRouter();
const btns = [
    {
        name: "หน้าแรก",
        path: "/",
    },
    {
        name: "เกี่ยวกับเรา",
        path: "/about",
    },
    {
        name: "บริการ",
        path: "/service",
    },
    {
        name: "ติดต่อเรา",
        path: "/contact",
    },
    {
        name: "นโยบายความเป็นส่วนตัว",
        path: "/privatePolicy",
    },
    {
        name: "ข้อตกลงสินเชื่อ",
        path: "/loanAgreement",
    },
];
const handleClick = (path) => {
    console.log("path", path);
    router.replace(path);
};
</script>
<style lang="less" scoped>
.box {
    height: 97px;
    padding: 0 196px;
    display: flex;
    align-items: center;
    position: relative;

    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 6px;
        background: url(../assets/head-bottom.webp) no-repeat;
        background-size: 100% 100%;
    }

    .logo {
        width: 482px;
        object-fit: cover;
        margin-right: 134px;
    }

    .btns {
        display: flex;
        justify-content: space-around;
        flex: 1;

        .btn {
            font-weight: bold;
            font-size: 12px;
            line-height: 12px;
            cursor: pointer;
            padding: 7px 13px;
            text-align: center;
            text-wrap: nowrap;
            border-radius: 13px;
        }
    }
}
</style>